import React from 'react';
import PropTypes from 'prop-types';

/**
 * Decorative topo-style mini map for club cards (mockup parity).
 * Not a live Mapbox instance — keeps the list page lightweight.
 */
export function ClubMiniMap({ clubId, acreage, standCount, hasBoundary }) {
  const standDots = [
    { x: 25, y: 30 },
    { x: 70, y: 25 },
    { x: 55, y: 55 },
    { x: 30, y: 70 },
    { x: 80, y: 65 },
  ].slice(0, Math.min(5, Math.max(standCount, hasBoundary ? 1 : 0)));

  const acreageLabel =
    acreage != null && !Number.isNaN(Number(acreage))
      ? `${Number(acreage).toLocaleString()} AC`
      : null;

  return (
    <div className="club-card-mini-map" aria-hidden="true">
      <svg className="club-card-mini-map__grid" viewBox="0 0 100 100" preserveAspectRatio="none">
        <defs>
          <pattern id={`club-grid-${clubId}`} width="10" height="10" patternUnits="userSpaceOnUse">
            <path
              d="M 10 0 L 0 0 0 10"
              fill="none"
              stroke="currentColor"
              strokeWidth="0.35"
            />
          </pattern>
        </defs>
        <rect width="100" height="100" fill={`url(#club-grid-${clubId})`} />
        <ellipse cx="60" cy="40" rx="22" ry="12" fill="none" stroke="currentColor" strokeWidth="0.4" opacity="0.5" />
        <ellipse cx="60" cy="40" rx="14" ry="7" fill="none" stroke="currentColor" strokeWidth="0.4" opacity="0.5" />
        <ellipse cx="30" cy="70" rx="18" ry="10" fill="none" stroke="currentColor" strokeWidth="0.4" opacity="0.5" />
        {hasBoundary ? (
          <polygon
            points="12,18 82,14 90,42 88,78 48,88 12,76 10,38"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeDasharray="3,2"
            className="club-card-mini-map__boundary"
          />
        ) : null}
      </svg>
      {standDots.map((pos, i) => (
        <span
          key={i}
          className="club-card-mini-map__stand"
          style={{ left: `${pos.x}%`, top: `${pos.y}%` }}
        />
      ))}
      {acreageLabel ? <span className="club-card-mini-map__acreage">{acreageLabel}</span> : null}
      {!hasBoundary ? (
        <span className="club-card-mini-map__placeholder">No boundary set</span>
      ) : null}
    </div>
  );
}

ClubMiniMap.propTypes = {
  clubId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  acreage: PropTypes.number,
  standCount: PropTypes.number,
  hasBoundary: PropTypes.bool,
};

ClubMiniMap.defaultProps = {
  acreage: null,
  standCount: 0,
  hasBoundary: false,
};
